import { Component, Input, OnInit } from "@angular/core";
import { faExclamationCircle } from "@fortawesome/pro-solid-svg-icons";
import { VAIconRegistryService, fileExcel } from "@va/core-library/icons";
@Component({
  selector: "app-reporting-model-renderer",
  template: `
    <span>
      <span
        class="icon-link"
        *ngIf="!linkObj.disabled && !linkObj.showInfoIcon"
        (click)="linkObj.clickCallback(linkObj.clickData)"
        nz-tooltip
        nzTooltipTitle="{{ linkObj.title }}"
      >
        <va-icon size="small" name="file-excel" class="link-icon"></va-icon>
        <span class="icon-text">
          <span>
            {{ linkObj.linkText }}
          </span>
        </span>
      </span>
      <span
        class="icon-link disabled"
        *ngIf="linkObj.disabled && !linkObj.showInfoIcon"
        nz-tooltip
        nzTooltipTitle="{{ linkObj.title }}"
      >
        <va-icon size="small" name="file-excel" class="link-icon"></va-icon>
        <span class="icon-text">
          {{ linkObj.linkText }}
        </span>
      </span>
      <span
        class="icon-link"
        *ngIf="linkObj.showInfoIcon"
        nz-tooltip
        nzTooltipTitle="{{ linkObj.title }}"
      >
        <va-icon
          size="small"
          [name]="faInfoCircle"
          isFontAwesome="true"
          class="link-icon-info"
        ></va-icon>
      </span>
    </span>
  `,
  styles: [
    `
      .icon-link {
        cursor: pointer;
        color: #000;
        font-size: 14px;
      }
      .icon-text {
        cursor: pointer;
        color: #1874ae;
        font-size: 12px;
      }
      .disabled {
        opacity: 0.4;
      }
      .link-icon-info {
        cursor: pointer;
        color: #36abad;
        font-size: 14px;
      }
    `,
  ],
})
export class ReportingModelRendererComponent implements OnInit {
  faInfoCircle = faExclamationCircle;
  @Input() linkObj: any;
  BAML_SOURCEID = 3;

  constructor(private iconRegistry: VAIconRegistryService) {
    this.iconRegistry.registerIcons([fileExcel]);
  }

  ngOnInit() {
    if (!this.linkObj) {
      this.linkObj = {};
    }
    this.linkObj.disabled = false;
    this.linkObj.showInfoIcon = false;
    const rowObject = this.linkObj;

    const rowObjectStatus = rowObject.sourceStatus
      ? rowObject.sourceStatus.toLowerCase()
      : "";

    if (
      "restrict" === rowObjectStatus ||
      "review" === rowObjectStatus ||
      "review_extended" === rowObjectStatus
    ) {
      this.linkObj.title = "No Current Model.";
      this.linkObj.showInfoIcon = true;
    } else if (rowObject.entitled && !rowObject.downloadApplicable) {
      // TODO : change the text for BAML to BOFA later
      this.linkObj.title = "A downloadable model is not currently available.";
      this.linkObj.disabled = true;
    } else if (rowObject.entitled) {
      this.linkObj.title = "Download Current Model";
    } else {
      this.linkObj.title = "You are not entitled\nto download this model.";
      this.linkObj.disabled = true;
    }
  }
}
